// extracted by css-extract-rspack-plugin
export default {"layout":"EE4SboLDvUYbi0Ye","resizeHandle":"xBBHbIuimf4vQPGR","toggle":"KfxzXx_Il2Q7YmRh","tooltip":"AxXBIoBMBRUjiZn0"};